import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useSort, SortSelect } from "@/lib/sort";

const W_COLS = { created_at: (w) => w.created_at, order_number: (w) => w.order_number, name: (w) => w.name, status: (w) => w.status };
const W_OPTS = [["created_at", "Data"], ["order_number", "Ordine"], ["name", "Cliente"], ["status", "Stato"]];

const STATES = { ricevuto: "Ricevuto", accettato: "Accettato", non_applicabile: "Non applicabile (personalizzato)", rimborsato: "Rimborsato" };

export function AdminWithdrawals() {
  const [list, setList] = useState(null);
  const load = () => api.get("/admin/withdrawals").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const { rows, sort, setSort } = useSort(list, W_COLS, { key: "created_at", dir: "desc" });
  const setStatus = async (w, status) => {
    try { await api.put(`/admin/withdrawals/${w.id}`, { status }); toast.success("Stato aggiornato"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-4xl font-extrabold uppercase">Recessi</h1>
        <p className="text-sm text-slate-500">Dichiarazioni inviate dai clienti con il pulsante "Recedere dal contratto qui". Il cliente riceve in automatico l'avviso di ricevimento via email.</p>
      </div>
      {list?.length === 0 && <p className="text-slate-500" data-testid="admin-withdrawals-empty">Nessuna richiesta di recesso.</p>}
      {list?.length > 1 && <SortSelect options={W_OPTS} sort={sort} setSort={setSort} testid="withdrawals-sort" />}
      <div className="space-y-3">
        {rows?.map((w, i) => (
          <div key={w.id} className="rounded-xl border bg-white p-4 grid md:grid-cols-[1fr_280px] gap-3 text-sm" data-testid={`admin-withdrawal-${i}`}>
            <div className="space-y-1">
              <div className="font-mono font-semibold"><Link to={`/admin/ordini/${w.order_id}`} className="underline">{w.order_number}</Link> · {new Date(w.created_at).toLocaleString("it-IT")}</div>
              <div>{w.name} · {w.email}</div>
              <div><b>Beni:</b> {w.items}</div>
              {w.notes && <div className="text-slate-600"><b>Note:</b> {w.notes}</div>}
            </div>
            <select data-testid={`admin-withdrawal-status-${i}`} value={w.status} onChange={(e) => setStatus(w, e.target.value)} className="h-10 px-3 rounded-md border border-slate-200 bg-white self-start w-full">
              {Object.entries(STATES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
